// Must match ACCOUNT_SUSPENDED_DETAIL / ACCOUNT_DELETED_DETAIL in backend/server.py
// exactly -- the backend returns these as a 403 `detail` on login and on every
// authenticated request once an admin suspends or soft-deletes the account.
export const ACCOUNT_SUSPENDED_DETAIL =
  'Your account has been suspended. Please contact support if you think this is a mistake.';
export const ACCOUNT_DELETED_DETAIL =
  'This account has been deleted. Please contact support if you think this is a mistake.';

export const isAccountBlockedError = (error) => {
  const detail = error?.response?.data?.detail;
  return error?.response?.status === 403
    && (detail === ACCOUNT_SUSPENDED_DETAIL || detail === ACCOUNT_DELETED_DETAIL);
};
